import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import InvoicesListCard from "./InvoicesListCard";


export default function InvoicesListPage() {

    return (
        <Container 
        style={{
            maxWidth: '1250px',
            width: '95%',
            margin: '0 auto'
        }}>
            <Row>
                <Col>
                    <InvoicesListCard options={{ onlyPurchases: true }} />
                </Col>
            </Row>
        </Container>
    );
}
